import { render } from "./team.vue?vue&type=template&id=4c47fec9&scoped=true&ts=true"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"

import "./team.vue?vue&type=style&index=0&id=4c47fec9&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c47fec9"]])

export default __exports__